import React from 'react';
import { INamedCohortInfoProps } from '../types';
import { useCurrentUrl } from '../../../utils/routing';
import { assertNotNil } from '../../../utils/types';
import { appRoutes } from '../../../path';
import { getCohortPagePath } from '../../../utils';
import * as BuilderInfoUI from '../BuilderInfoUI';
import {
  GoToDictionaryAction,
  InfoPopupHeader,
  ShowInReport,
} from '../components';
import CohortDetails from '../components/CohortDetails';
import {
  getUrlForDataSharing,
  SearchParamsDataSharingEnum,
} from '../../../utils/searchParamsDataSharing';
import { useEntityInfoPopoverContext } from '../../EntityInfoPopover/EntityInfoPopoverContext';

export default ({ cohort, isExpanded, onExpand }: INamedCohortInfoProps) => {
  const { isReportInUrl, isCreateCohortInUrl } = useCurrentUrl();

  const { id, version, createdAt, creator, schema } = cohort;

  assertNotNil(version);

  const entityInfoPopoverContext = useEntityInfoPopoverContext();

  const isCompound = cohort.__typename === 'CompoundCohort';

  const { name, description, comment } = version;

  const shouldShowExpand =
    typeof onExpand === 'function' && !isExpanded && !isCompound; // do not expand compound cohorts.

  const showInReportAvailable = !isCreateCohortInUrl;

  const reportUrl = getCohortPagePath(id);

  const dictionaryUrl = getUrlForDataSharing(appRoutes.cohorts.view, {
    type: SearchParamsDataSharingEnum.Dictionary,
    schemaId: schema.id,
    term: name,
  });

  const handleExpand = (event: React.SyntheticEvent) => {
    assertNotNil(onExpand);
    onExpand();
    entityInfoPopoverContext.closePopover(event);
  };

  return (
    <>
      <InfoPopupHeader
        name={name}
        description={description}
        creator={creator}
        editor={version.editor}
        editedAt={version.editedAt}
        comment={comment}
        createdAt={createdAt}
        link={
          isReportInUrl && dictionaryUrl ? (
            <GoToDictionaryAction dictionaryUrl={dictionaryUrl} />
          ) : null
        }
      />
      <BuilderInfoUI.MainContent>
        <CohortDetails
          cohort={cohort}
          sampleOperation={null}
          samplePercentage={null}
          sampleAbsolute={null}
        />
      </BuilderInfoUI.MainContent>
      {(shouldShowExpand || showInReportAvailable) && (
        <BuilderInfoUI.FooterContainer>
          {shouldShowExpand && (
            <BuilderInfoUI.PopupSecondaryButton
              type="button"
              onClick={handleExpand}
              trackContext="cohorts"
              trackAction="expand"
              size="small"
            >
              Expand
            </BuilderInfoUI.PopupSecondaryButton>
          )}
          {showInReportAvailable && (
            <ShowInReport reportUrl={reportUrl} trackContext="cohorts" />
          )}
        </BuilderInfoUI.FooterContainer>
      )}
    </>
  );
};
